import React from "react";
import moment from "moment";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col
} from "reactstrap";

import { getSellerRequest } from "api/seller";
import History from "components/History/History";
import { Link } from "react-router-dom";
class SellerDetails extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      seller: null,
      addingEntry: false,
      newEntryText: "",
      saving: false,
    };
  }

  async componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get("id");

    if (id) {
      const seller = await getSellerRequest(id);
      this.setState({
        seller,
      });
    } else {
      this.goTo("/sellers");
    }
  }

    goTo = (path) => this.props.history.push(path);

    render() {

      const {
        seller
      } = this.state;

      const {
        _id,
        first_name,
        last_name,
        broker,
        gender,
        email,
        phone,
        dateOfBirth,
        companyAddress,
        isVatable,
        prcNumber,
        prcDate,
        pcrExpiration
      } = seller || {} 

        return (
            <>
                <div className="content">
                <Row>
                    <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h3">
                                Seller Details
                                <Button
                                className="float-right"
                                color="default"
                                 onClick={() => this.goTo("/sellers")}
                                >
                                Back
                                </Button>
                                <Button
                                className="float-right mr-2"
                                color="default"
                                onClick={() => this.goTo(`/seller/edit?id=${_id}`)}
                                >
                                Edit
                                </Button>
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                      <Card>
                                <CardBody>
                                  <Row>
                                    <Col sm="6">
                                    
                                    <div className="typography-line">
                                        <h4>
                                          <span>ID</span>
                                          {_id}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>First Name</span>
                                          {first_name || "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>Last Name</span>
                                          {last_name || "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>Broker</span>
                                          {broker ? 
                                          <Link to={`broker?id=${broker._id}`}>
                                            {broker?.name} 
                                          </Link>
                                          :
                                           "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>Gender</span>
                                          {gender || "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>Date of Birth</span>
                                          {dateOfBirth ? moment(dateOfBirth).format("MM/DD/YYYY") : "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>Phone</span>
                                          {phone || "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>Email</span>
                                          {email || "N/A"}
                                        </h4>
                                      </div>
                                      
                                      <div className="typography-line">
                                        <h4>
                                          <span>Company Address</span>
                                          {companyAddress ? 
                                            `${companyAddress.street || ''}, 
                                             ${companyAddress.city || ''}, 
                                             ${companyAddress.state || ''}, 
                                             ${companyAddress.country || ''}, 
                                             ${companyAddress.zipCode || ''}` 
                                            : 'N/A'}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>Is Vatable</span>
                                          {isVatable ? 'Yes' : 'No'}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>PRC Number</span>
                                          {prcNumber || "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>PRC Date</span>
                                          {prcDate ? moment(prcDate).format("MM/DD/YYYY") : "N/A"}
                                        </h4>
                                      </div>
                                      <div className="typography-line">
                                        <h4>
                                          <span>PRC Expiration</span>
                                          {pcrExpiration ? moment(pcrExpiration).format("MM/DD/YYYY") : "N/A"}
                                        </h4>
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                        </CardBody>
                        <CardBody>
                          <History location={this.props.location} component={seller} type={'seller'} />
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                </div>
            </>
        )
    }
}

export default SellerDetails;